import { render, staticRenderFns } from "./successStep.vue?vue&type=template&id=67c806d8&scoped=true"
import script from "./successStep.vue?vue&type=script&lang=js"
export * from "./successStep.vue?vue&type=script&lang=js"
import style0 from "./successStep.vue?vue&type=style&index=0&id=67c806d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c806d8",
  null
  
)

export default component.exports